import { event, id, list, project, retrieveEventError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRetrieveEventError(eventId) {
      const res = getState().find(({ id }) => id === eventId);

      return res ? res.error : retrieveEventError;
    },
    getEvent(eventId) {
      const res = getState().find(({ id }) => id === eventId);

      return res
        ? res.event
        : {
            ...event,
            uuid: eventId,
            list: { ...list, uuid: id },
            project: { ...project, uuid: id },
          };
    },
    isRetrieveEventRequestFailure(eventId) {
      const res = getState().find(({ id }) => id === eventId);

      return res ? res.request.isFailure : false;
    },
    isRetrieveEventRequestPending(eventId) {
      const res = getState().find(({ id }) => id === eventId);

      return res ? res.request.isPending : false;
    },
    isRetrieveEventRequestSuccess(eventId) {
      const res = getState().find(({ id }) => id === eventId);

      return res ? res.request.isSuccessful : false;
    },
    hasRetrievedEvent(eventId) {
      const res = getState().find(({ id }) => id === eventId);

      return res ? res.request.isSuccessful || res.request.isFailure : false;
    },
  };
}

export { createSelector };
